import cookies from './cookies';
import carvanaId from './partners';

export { cookies as COOKIES, carvanaId };

export const MAX_PAGE_SIZE_DEFAULT = 24;

export const SHIPPING_EXCLUDED_STATES = ['AK', 'HI'];

export const LOW_RESULTS_THRESHOLD = 16;

export const LOW_RESULTS_COUNT = 12;
